import "./scrollable.css";

import { Page, PageHeader } from "@nike/epic-react-ui";
import { Declarants } from "../components/declarants/Declarants";
import { ImportersOfRecord } from "../components/importers-of-record/ImportersOfRecord";
import { Bonds } from "../components/bonds/Bonds";

export function MasterData({ history }) {
  return (
    <Page
      documentTitle="Master Data - Customs Compliance Hub"
      width="full"
      className="scrollable"
    >
      <PageHeader
        title="Master Data"
        summary="Data relating to product or parties used for reference purposes to support Nike's import, export, and logistics transactions."
      />
      <Declarants />
      <ImportersOfRecord />
      <Bonds />
    </Page>
  );
}
